import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import bounceInBottomGif from '../../../assets/images/transitions/bounceInBottom.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_BOUNCE_OUT_BOTTOM = 'bounceOutBottom';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const bounceOutBottomPresetDetails = {
  // The name of the preset.
  name: PRESET_BOUNCE_OUT_BOTTOM,

  // A human friendly name for the preset.
  humanName: 'Bounce Out to Bottom',

  // A preview of the transition.
  gif: bounceInBottomGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      // The name of the easing this property will use.
      easing: EASINGS.easeInElastic,

      // The start and end times for the transition of this property.
      time: {
        end: 'end.0',
        start: 'end.-1300'
      },

      // The value of the property that will change during the transition.
      values: [
        'position.bottom',
        'off.bottom'
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_BOUNCE_OUT_BOTTOM,
    options: {},
  },
};

bounceOutBottomPresetDetails.template.options = lodash.cloneDeep(bounceOutBottomPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_BOUNCE_OUT_BOTTOM;

// This defines the value of the presets object.
export default bounceOutBottomPresetDetails;
